module.exports = __webpack_public_path__ + "assets/view_3d.e5ef90a0.svg";